export default "__VITE_PUBLIC_ASSET__02558ff4__"